<template>
  <div class="mt-4 chart-item" :style="{ height: chartHeightRounded + 'px' }">
    <div :id="label + '-cvs-container'" class="ecg-container">
      <span class="ecg-label" :style="{'color': `rgba(${color.r * 255}, ${color.g * 255}, ${color.b * 255}, 255)`}">{{label}}</span>
      <span class="ecg-label label-left" :style="{'color': `rgba(${color.r * 255}, ${color.g * 255}, ${color.b * 255}, 255)`}">{{time}}</span>
      <canvas class="ecg-grid" :id="label + '-grid'" style="width: 100%; height: 100%;"></canvas>
      <canvas class="ecg-chart" :id="label + '-cvs'" :style="{width: '100%', height: '100%'}"></canvas>
      <div :id="label + '-chart-wrapper'" class="ecg-chart-wrapper" :class="label + '-chart-wrapper'">
        <div :style="{width: `${chartWidth}px`, height: '1px'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { WebglPlot, WebglLine, ColorRGBA } from 'webgl-plot'
import debounce from 'lodash/debounce'
import grid from '@/_helpers/grid.js'

export default {
  name: 'EcgChart',
  props: [
    'chartData',
    'duration',
    'color',
    'label',
    'max',
    'mmPerMV',
    'mmPerSec',
    'time',
    'chartHeight',
    'screenWidth',
    'screenWidthInMm',
    'calibrateValue'
  ],
  created () {
    this.scaleChangeFunc = debounce(this.initChart, 1000)
    this.timeChangeFunc = debounce(this.updateTime, 100)
  },
  destroyed () {
    if (this.wglp) {
      this.wglp.clear()
      this.wglp.removeAllLines()
    }
  },
  mounted () {
    this.initGrid()
    this.initChart()
  },
  data: () => ({
    wglp: null,
    canvas: null,
    chartWidth: 0,
    gridCanvas: null,
    grid: null,
    lineObj: null,
    heightChange: false,
    scaleChangeX: false,
    scaleChangeY: false,
    scaleChangeFunc: null,
    timeChangeFunc: null,
    timeOffsetIndex: 0,
    mvFactor: 1.0,
    chartHeightRounded: 0
  }),
  computed: {
    mvPerCell () {
      return 5 * (1 / this.mmPerMV)
    },
    timePerCell () {
      return 5 * (1 / this.mmPerSec)
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler () {
        //this.initChart()
        // debounced init chart
        this.scaleChangeFunc()
      }
    },
    mmPerSec (to, from) {
      this.scaleChangeX = true
      this.scaleChangeFunc()
    },
    mmPerMV (to, from) {
      this.scaleChangeY = true
      requestAnimationFrame(this.newFrame)
    },
    time (to, from) {
      this.timeChangeFunc()
    },
    screenWidthInMm (to, from) {
      initGrid()
      this.timeChangeFunc()
    }/* ,
    chartHeight (to, from) {
      this.heightChange = true
      this.scaleChangeX = true
      this.scaleChangeY = true
      this.initGrid()
      this.initChart()
    } */
  },
  methods: {
    initGrid () {
      if (this.screenWidthInMm < 0) {
        return
      }

      if (!this.grid || this.heightChange) {
        this.grid = grid()

        this.grid.majorStrokeStyle = 'rgba(191, 191, 191, 255)'
        this.grid.minorStrokeStyle = 'rgba(191, 191, 191, 100)'

        this.grid.majorLineWidth = 0.75
        this.grid.minorLineWidth = 0.25
      }

      const canvas = document.getElementById(`${this.label}-grid`)
      this.gridCanvas = canvas
      if (!canvas) {
        return
      }

      var context = canvas.getContext("2d")
      context.clearRect(0, 0, canvas.width, canvas.height)

      setTimeout(() => {
        const devicePixelRatio = window.devicePixelRatio || 1
        canvas.width = canvas.clientWidth * devicePixelRatio
        canvas.height = canvas.clientHeight * devicePixelRatio

        var pxPerMm = (this.screenWidth / this.screenWidthInMm) * this.calibrateValue / 100
        var cellSize = 5 * pxPerMm
        var cellsInHeight = this.chartHeight / cellSize
        var cellRounded = Math.ceil(cellsInHeight)
        if (cellRounded % 2 === 1) {
          cellRounded++;
        }
        canvas.height = cellRounded * cellSize
        this.chartHeightRounded = canvas.height

        this.grid.square(context, 0, 0, canvas.width, canvas.height, cellSize, cellSize / 5, null)

        this.heightChange = false
      }, this.heightChange? 100 : 1)
    },
    initChart () {
      if (!this.chartData || this.chartData.length === 0 || this.screenWidthInMm < 0) {
        return
      }

      const canvas = document.getElementById(`${this.label}-cvs`)
      this.canvas = canvas
      if (!canvas) {
        return
      }
      const devicePixelRatio = window.devicePixelRatio || 1
      canvas.width = canvas.clientWidth * devicePixelRatio
      canvas.height = canvas.clientHeight * devicePixelRatio

      var pxPerMm = (this.screenWidth / this.screenWidthInMm) * this.calibrateValue / 100
      var cellSize = 5 * pxPerMm
      var cellsInHeight = this.chartHeight / cellSize
      var cellRounded = Math.ceil(cellsInHeight)
      if (cellRounded % 2 === 1) {
        cellRounded++;
      }
      canvas.height = cellRounded * cellSize
      this.chartHeightRounded = canvas.height
      console.log('cellRounded', cellRounded, cellsInHeight, canvas.height, cellSize)

      // calculate maximmum mv that can show in chart
      this.mvFactor = (this.mvPerCell *  cellRounded / 2)
      this.chartWidth = (this.duration / this.timePerCell) * cellSize
      this.$emit('chartWidthChanged', this.chartWidth)

      var sampleCountPerCell = this.timePerCell * this.chartData.length / this.duration
      var numX = sampleCountPerCell * this.canvas.width / cellSize
      if (!numX || numX === NaN || numX <= 0) {
        console.log('no numx provided!')
        return
      }

      if (this.wglp) {
        this.wglp.clear()
        this.wglp.removeAllLines()
      }

      if (!this.wglp || this.scaleChangeX) {
        this.wglp = new WebglPlot(canvas)
      }

      if (this.lineObj === null || this.scaleChangeX) {
        this.lineObj = new WebglLine(this.color, numX)
        this.lineObj.arrangeX()
      }

      this.addChartLines()
      requestAnimationFrame(this.newFrame)
    },
    addChartLines() {
      this.wglp.removeAllLines()

      if (this.chartData) {
        this.wglp.addLine(this.lineObj)
      }
    },
    newFrame () {
      this.update()
      if (this.wglp) {
        this.wglp.update()
      }

      this.scaleChangeX = false
      this.scaleChangeY = false
      // requestAnimationFrame(this.newFrame)
    },
    update () {
      if (!this.canvas || !this.chartData || this.chartData.length === 0) {
        return
      }

      var numx = Math.min(this.lineObj.numPoints, 10000)
      var r = Math.floor((this.chartData.length - numx) * this.timeOffsetIndex)
      for (let i = 0; i < numx; i++) {
        this.lineObj.setY(i, this.chartData[i + r] / this.mvFactor)
      }
    },
    updateTime() {
      this.timeOffsetIndex = this.time / this.duration
      requestAnimationFrame(this.newFrame)
    }
  }
};
</script>

<style scoped>
.chart-item {
  width: 100%;
  max-height: 300px !important;
}

#chart-div {
  width: 100%;
  height: 80%;
}

.ecg-grid {
  position: absolute;
  top: 0;
  left: 0;
}

.ecg-container {
  width: 100%;
  height: 100%;
  border: 1px solid rgba(191, 191, 191, 255);
  position: relative;
}

.ecg-chart-wrapper {
  direction: ltr;
  overflow-x: scroll;
  overflow-y: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.ecg-label {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  font-weight: bold;
}

.label-left {
  right: unset;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/EcgChart.vue